module.exports = __webpack_public_path__ + "static/media/Rotary VR.6a6e35a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/hd-racks/Rotary VR.mp3
// module id = LMCi
// module chunks = 12